import { render, staticRenderFns } from "./AppPermissionScreen.vue?vue&type=template&id=ebcd679a"
import script from "./AppPermissionScreen.vue?vue&type=script&lang=js"
export * from "./AppPermissionScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports